export default __webpack_public_path__ + "static/Collaborate effectively-f078d17189211235ac75a518eeaa2d82.png";